import React, { useEffect, useState } from "react";
import { CheckCircle2, CircleAlert, Info, ChevronRight, ChevronDown } from "lucide-react";
import api from "@/lib/api";

export const ReadinessCard = ({ propertyId, onJump, rev }) => {
  const [r, setR] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get(`/properties/${propertyId}/readiness`).then((x) => setR(x.data)).catch(() => {}); }, [propertyId, rev]);
  if (!r || r.live || !r.items.length) return null;
  const blocking = r.items.filter((i) => i.blocking).length;
  return (
    <div data-testid="readiness-card" className="bg-white border border-border rounded-md">
      <button type="button" data-testid="readiness-toggle" onClick={() => setOpen(!open)} aria-expanded={open}
        className="w-full px-5 py-3 flex items-center gap-2 text-left hover:bg-secondary/40 transition-colors rounded-md">
        {r.ready ? <CheckCircle2 className="h-4 w-4 text-[#2B4C3F]" /> : <CircleAlert className="h-4 w-4 text-[#9E382A]" />}
        <span className="overline flex-1">{r.ready ? "Ready to go live" : "What's missing to go live"}</span>
        <span data-testid="readiness-count" className={`text-xs font-semibold px-2 py-0.5 rounded-full ${blocking ? "bg-[#9E382A]/10 text-[#9E382A]" : "bg-secondary text-muted-foreground"}`}>
          {blocking ? `${blocking} to complete` : `${r.items.length} note${r.items.length === 1 ? "" : "s"}`}
        </span>
        <ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="divide-y divide-border border-t border-border">
          {r.items.map((i, idx) => (
            <li key={idx}>
              <button type="button" data-testid={`readiness-item-${idx}`} disabled={!i.tab} onClick={() => i.tab && onJump(i.tab)}
                className="w-full flex items-center gap-3 px-5 py-2.5 text-left text-sm hover:bg-secondary/50 transition-colors disabled:cursor-default disabled:hover:bg-transparent">
                {i.blocking ? <span className="h-1.5 w-1.5 rounded-full bg-[#9E382A] shrink-0" /> : <Info className="h-3.5 w-3.5 text-muted-foreground shrink-0" />}
                <span className={`flex-1 ${i.blocking ? "" : "text-muted-foreground"}`}>{i.label}</span>
                {i.tab && <ChevronRight className="h-4 w-4 text-muted-foreground" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
